import Icon from '../components/Icon.vue'

Icon.register({
  'traffic-light': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 192c0 41.7-26.8 76.9-64 90.1v37.9h64c0 42.8-28.3 78.7-67 91-12.4 57.7-63.6 101-125 101s-112.6-43.3-125-101c-38.7-12.4-67-48.2-67-91h64v-37.9c-37.2-13.2-64-48.4-64-90.1h64v-37.9c-37.2-13.2-64-48.4-64-90.1h64v-32c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v32h64c0 41.7-26.8 76.9-64 90.1v37.9h64zM192 416c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM192 288c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM192 160c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/traffic-light.js
// module id = 1819
// module chunks = 0